export default __webpack_public_path__ + "static/media/comments.20e01225.svg";